import { styled } from "styled-components";

const Wrapper = styled.button`
  background: transparent;
  background-color: transparent;
  border-color: transparent;
  width: 2.5rem;
  height: 2rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: var(--transition);
  @media screen and (max-width: 900px) {
    margin: 0 auto;
    width: 3rem;
    height: 3rem;
  }
  .toggle-icon {
    font-size: 1.15rem;
    color: var(--text-color);
  }
  img {
    border-radius: 50px;
    background: var(--background-secondary-color);
  }
`;

export default Wrapper;
